// extracted by mini-css-extract-plugin
export default {"title":"newsId_title__N68cW","prevPath":"newsId_prevPath__rB-zq"};